import { BaseApp, Constance } from "../core/app";
import { ActionBarButton, ActionBarItemGroup } from "../core/action-bar/item";
import ValtasiirtoDatabase from "./db/index";
import ConfirmModal from "../core/modals/confirm/index";
import AuthenticationModal from "../core/modals/authentication/index";
import { JobListButton, JobTaskListButton, TestChainButton, TestDataBindsButton } from "./actionbar";
import Router from "../core/router/index";
import ActionBar from "../core/action-bar/index";
import ViewProcessorManager from "../core/view/processor/index";
import TabControlViewProcessor from "../core/view/processor/tab-control";
import FlipcardViewPostProcessor from "../core/view/processor/flipcard";
import { AttributeKey } from "../core/db/models/attributes";
import ErrorModal from "../core/modals/error/index";
import { SyncButton, LogoutButton, HomeButton } from "../core/action-bar/items/index";

/**
 * Base application for all Valtasiirto client applications. 
 * Contains shared functionality that doesn't concern the BaseApp class.
 */
export abstract class ValtasiirtoBaseApp extends BaseApp
{
    public db: ValtasiirtoDatabase;
    public constance: ValtasiirtoConstance;

    public get apiToken(): string { return this.userSettings.token; }

    public init(): PromiseLike<void>
    {
        this.on('refreshRequired', this.onRefreshRequired);
        return super.init().then(() => 
        {
            
        }, error => 
        {
            this.error(error);
        });
    }
    
    protected initDatabase(): PromiseLike<void>
    {
        this.db = new ValtasiirtoDatabase(this.settings.clientSync.databaseName);
        return super.initDatabase();
    }

    public configureRouter(router: Router)
    {
        super.configureRouter(router);
    }

    public configureActionbar(actionBar: ActionBar) 
    {
        super.configureActionbar(actionBar);
        
        actionBar.add(SyncButton);
        actionBar.add(JobListButton);
        actionBar.add(JobTaskListButton);
        actionBar.add(LogoutButton);
        actionBar.add(HomeButton);
    }

    public configureViewProcessors(processors: ViewProcessorManager)
    {
        super.configureViewProcessors(processors);

        processors.add(TabControlViewProcessor);
        processors.add(FlipcardViewPostProcessor);
    }

    public logout(): void
    {
        this.db.Attribute.delete(AttributeKey.CURRENT_USER);
        this.refresh();
    }
}

export interface ValtasiirtoConstance extends Constance
{
    ORDER_ITEM_IS_LATE_THRESHOLD: number;
}